// extracted by mini-css-extract-plugin
export default {"tag":"MGTag_tag__SXmYH","label":"MGTag_label__nb6PN","close":"MGTag_close__ZgyA4"};